import * as React from 'react';

import Button from '../../Button';
import { IModalProps, Modal } from '../../Modal';
import { IOrder } from '../../../infrastructure/interfaces';

import './ShippingModal.css';

export interface IChangeImageModalProps extends IModalProps {
  order: IOrder | null;
}

export default class ShippingModal extends React.Component<IChangeImageModalProps, any> {
  constructor(props: IChangeImageModalProps) {
    super(props);
  }

  onClose = () => {
    this.props.onClose();
  }

  render() {

    if (this.props.order == null) {
      return (
        <Modal show={this.props.show} onClose={this.props.onClose} className="admin-modal">
          <Modal.Header>
            <Modal.Title>
              <div className="title admin-shipping-title">
                Missing Order
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.onClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      );
    }
  
    return (
      <Modal show={this.props.show} onClose={this.props.onClose} className="admin-modal">
        <Modal.Header>
          <Modal.Title>
            <div className="title admin-shipping-title">
              Shipping Information
            </div>
            <div className="title admin-shipping-sub-title">
              The requested shipping address is below
            </div>
          </Modal.Title>
          <Button bsClass="close" onClick={this.onClose}></Button>
        </Modal.Header>
        <Modal.Body>
          <div className="admin-shipping-container">
            <div className="manage-shipping-table">
              <div>
                <div>Contact Email</div>
                <div>{this.props.order.shipEmail}</div>
                <div>Comments</div>
                <div>{this.props.order.comments}</div>
              </div>
            </div>
          </div>
          {
            this.props.order.orderQuantitiesAddresses.map((addressQuantity) => (
              <div className="admin-shipping-container">
                <div className="manage-shipping-table">
                  <div>
                    <div>Address</div>
                    <div>
                      {addressQuantity.address.shipName}<br/>
                      {addressQuantity.address.shipAddress1} {addressQuantity.address.shipAddress2}<br/>
                      {addressQuantity.address.shipCity}, {addressQuantity.address.shipState} {addressQuantity.address.shipPostalCode}<br/>
                      {addressQuantity.address.shipCountry}<br/>
                      <br/>
                    </div>
                    <div>Quantity</div>
                    <div>{addressQuantity.orderQuantity}</div>
                  </div>
                </div>
              </div>
            ))
          }

        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.onClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modals/ShippingModal/ShippingModal.tsx